<template>
  <div class="ibox">
    <div class="ibox-content p-t-m">
      <div class="row">
        <div class="col-xs-12 col-md-2 hidden-print">
          <div class="m-t-xl m-t-only-xs-m">
            <a href="/event_invites" class="btn btn-block btn-outline btn-primary">
              <i class="fa-solid fa-inbox m-r-xs"></i>
                Invites
                <template v-if="pendingEventInviteCount > 0">
                  <span class="badge" style="background-color: #27AA83; color: white; margin-right: 1px;">{{ pendingEventInviteCount }} pending</span>
                </template>
            </a>
            <p class="text-10 text-center m-t-xxs">Respond to events you've been invited to</p>
          </div>

          <div class="m-t-xl">
            <a href="/private_lessons" class="btn btn-block btn-outline btn-primary flex align-items-center flex-wrap gap-xs justify-center">
              <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 640 512" class="h-6 w-6 text-green-600"><!-- Font Awesome Pro 5.15.4 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) --><path d="M250.6 254c0 22.3-18.1 40.4-40.4 40.4s-40.4-18.1-40.4-40.4c0-22.3 18.1-40.4 40.4-40.4s40.4 18.1 40.4 40.4zm231.9-50.2L633.9 325c6.8 5.5 8.1 15.3 2.8 22.3l-79 105.3c-4.9 6.5-13.9 8.4-20.9 4.3l-151.7-86.8c-7.6 11.4-16.4 22.3-26.5 32.4-41 41-94.7 61.5-148.5 61.5-157 0-258.4-166.6-186.8-306A64.714 64.714 0 0 1 .2 108.4c0-35.6 29-64.6 64.6-64.6 19.2 0 36.9 8.8 49.1 23.4C144 51.7 177 44.1 210 44.1c86.7 0 126.5 42.9 194.5 97.3 5.3 4.3 7.4 11.4 5.2 17.9L399.5 189c-1.1 3.2-.1 6.8 2.6 8.9l25.5 20.4c2.6 2.1 6.3 2.4 9.2.6l27.5-16.4c5.7-3.4 13-2.9 18.2 1.3zM41 129.8c6.3-8.5 13-16.8 20.7-24.5 7.8-7.8 16.1-14.6 24.7-20.9-5.9-5.3-13.5-8.3-21.6-8.3-17.8 0-32.3 14.5-32.3 32.3 0 8.1 3.3 15.6 8.5 21.4zm533.5 219.7c2.6-3.5 2-8.4-1.4-11.2l-103.4-82.7-32.3 19.2c-5.8 3.4-13.1 2.9-18.3-1.3L349.6 218c-5.3-4.3-7.4-11.4-5.2-17.9l12.1-35.2s-52-41.5-60.6-47.8C262.1 95.9 170.5 65 96 139.5 33 202.5 33 305 96 368c30.5 30.5 71.1 47.5 114.2 47.5 102.1 0 142.2-83.7 159.7-109.9L530 397.2c3.5 2 8 1.1 10.5-2.2l34-45.5z"/></svg>
              <span>Private Lessons</span>
              <template v-if="eventBookingInvitedCount > 0">
                <span class="badge" style="background-color: #27AA83; color: white; margin-right: 1px;">{{ eventBookingInvitedCount }} invites</span>
              </template>
            </a>
            <p class="text-10 text-center m-t-xxs">Schedule or manage private lessons</p>
          </div>
          <hr/>
          <div role="form" class="calendar-filter p-t-xs">
            <h3 class="m-t-none font-semi m-b-md">Team Schedule Filters</h3>
            <vertical-expander expand-for="EventType" :default-open="true">
              <template v-slot:title>
                <p class="m-t-none font-heavy m-b-xs">Event type</p>
              </template>
              <template v-slot:content>
                <div class="grid grid-cols-1 gap-y-3">
                  <div class="form-group m-b-none">
                    <label class="checkbox-inline matches">
                      <input type="checkbox" v-model="matchesVisible"> Matches
                      <spinner v-if="matchesLoading"></spinner>
                    </label>
                  </div>
                  <div class="form-group m-b-none">
                    <label class="checkbox-inline other">
                      <input type="checkbox" v-model="otherVisible"> Other
                      <spinner v-if="otherLoading"></spinner>
                    </label>
                  </div>
                  <div class="form-group m-b-none">
                    <label class="checkbox-inline practice">
                      <input type="checkbox" v-model="practiceVisible"> Practices
                      <spinner v-if="practiceLoading"></spinner>
                    </label>
                  </div>
                  <div class="form-group m-b-none">
                    <label class="checkbox-inline tournament">
                      <input type="checkbox" v-model="tournamentVisible"> Tournaments
                      <spinner v-if="tournamentLoading"></spinner>
                    </label>
                  </div>
                  <div class="form-group m-b-none" v-if="showPrivateLessons">
                    <label class="checkbox-inline private-lesson">
                      <input type="checkbox" v-model="privateLessonsVisible"> My Private Lessons
                      <spinner v-if="privateLessonsLoading"></spinner>
                    </label>
                  </div>
                </div>
              </template>
            </vertical-expander>
            <vertical-expander expand-for="RosterFilter" :default-open="true">
              <template v-slot:title>
                <p class="m-t-md font-heavy m-b-xs">Roster</p>
              </template>
              <template v-slot:content>
                <div class="grid grid-cols-1 gap-y-xs">
                  <div>
                    <label class="flex align-items-center gap-xs m-b-none">
                      <input type="radio" value="all" id="all-rosters" v-model="rosterFilter" class="m-t-none-important">
                      <span>All rosters</span>
                    </label>
                  </div>
                  <div>
                    <label class="flex align-items-center gap-xs m-b-none">
                      <input type="radio" value="specific" id="specific-rosters" v-model="rosterFilter" class="m-t-none-important">
                      <span>Specific roster(s)</span>
                    </label>
                    <div class="-m-t-xs" v-if="rosterFilter === 'specific'">
                      <div class="flex flex-wrap gap-xxs m-b-xs m-t-xs">
                        <button @click="toggleRoster(r)" class="btn btn-success btn-outline rounded-lg font-small"
                                style="padding: 2px 6px;" v-for="r in rostersForFilterArray">
                          {{ r.name }}
                          <i class="fa-solid fa-xmark"></i>
                        </button>
                      </div>
                      <search
                          class="search-form"
                          response-key="rosters"
                          placeholder="Type the name of a roster..."
                          :mutate-history="false"
                          :allow-add="false"
                          only-dismiss-model="Roster"
                          :small-input="true"
                          :display-all-on-empty="false"
                          readable-model-name="roster"
                          base-url="/api/v1/rosters">
                        <template v-slot:list="slotProps">
                          <div
                              class="border-top m-t-sm m-b-xs p-t-sm p-b-xs cursor-pointer flex justify-space-between align-items-center p-r-sm"
                              @click="toggleRoster(slotProps.result)">
                            <div>
                              {{ slotProps.result.name }}
                            </div>
                            <div class="border rounded-sm border-blue-200 border-solid font-small"
                                 style="padding: 2px 6px;">
                              Filter
                            </div>
                          </div>
                        </template>
                      </search>
                    </div>
                  </div>
                </div>
              </template>
            </vertical-expander>
            <vertical-expander v-if="locations.length > 0" expand-for="LocationFilter" :default-open="true">
              <template v-slot:title>
                <p class="m-t-md font-heavy m-b-xs">Location</p>
              </template>
              <template v-slot:content>
                <div class="grid grid-cols-1 gap-y-xs">
                  <div>
                    <label class="flex align-items-center gap-xs m-b-none">
                      <input type="radio" value="all" id="all-locations" v-model="locationFilter" class="m-t-none-important">
                      <span>All locations</span>
                    </label>
                  </div>
                  <div class="grid grid-cols-1 gap-y-xs">
                    <label class="flex align-items-center gap-xs m-b-none">
                      <input type="radio" value="specific" id="specific-locations" v-model="locationFilter" class="m-t-none-important">
                      <span>Specific location(s)</span>
                    </label>
                    <div v-if="locationFilter === 'specific'" class="grid grid-cols-1 gap-y-xs m-l-m">
                      <label v-for="location in locations" :key="location.id" class="flex align-items-center gap-xs font-normal m-b-none">
                        <input type="checkbox" :value="location.id" v-model="locationIdsChecked" class="m-t-none-important">
                        <span>{{ location.name }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </template>
            </vertical-expander>
          </div>
          <div id="calendar-delete" class="m-t-sm">
            <div class="text-danger border rounded-sm border-red-200 border-solid p-sm" v-show="dragging">
              <i class="fa-regular fa-trash-can m-r-xs"></i><span>Drag here to delete event</span>
            </div>
            <delete-event-form v-if="deleteForm" :event="eventForDeletion" :recurring="deleteEventRecurring">
            </delete-event-form>
          </div>
          <div v-if="error">
            <small><span class="text-danger">{{ errorMessage }}</span></small>
          </div>
          <hr/>
          <div>
            <button class="btn btn-success btn-outline btn-block" @click="toggleSubscribeModal()">Subscribe...</button>
            <p class="text-10 text-center m-t-xxs">Sync to your personal calendar</p>
          </div>
        </div>
        <div class="col-xs-12 col-md-10">
          <div>
            <div v-if="calendarOptionsLoaded">
              <FullCalendar :options="calendarOptions" ref="calendar" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="event-update-modal" class="modal fade hidden-print system-background system-label" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog system-background system-label" role="document">
            <div class="modal-content p-lg system-background system-label">
                <div>
                    <div class="flex gap-sm align-items-center justify-space-between m-b-sm">
                        <h2 class="font-heavy m-t-none m-b-none">Update Repeated Events?</h2>
                        <div class="flex h-12 w-12 align-items-center justify-center rounded-full bg-green-100">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8 text-green-700">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 0 0-3.7-3.7 48.678 48.678 0 0 0-7.324 0 4.006 4.006 0 0 0-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 0 0 3.7 3.7 48.656 48.656 0 0 0 7.324 0 4.006 4.006 0 0 0 3.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3-3 3" />
                            </svg>
                        </div>
                    </div>
                    <repeated-event-update v-if="updatingRepeatedEvent" :event="repeatedEventForUpdate" :params="repeatingEventForUpdateParams"></repeated-event-update>
                </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
    <div id="event-notify-modal" class="modal fade hidden-print system-background system-label" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
         <div class="modal-dialog system-background system-label" role="document">
            <div class="modal-content p-lg system-background system-label">
              <div>
                <div class="flex gap-sm align-items-center justify-space-between m-b-sm">
                  <h2 class="font-heavy m-t-none m-b-none">Notifications</h2>
                  <div class="flex h-12 w-12 align-items-center justify-center rounded-full bg-green-100">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8 text-green-700">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0M3.124 7.5A8.969 8.969 0 0 1 5.292 3m13.416 0a8.969 8.969 0 0 1 2.168 4.5" />
                    </svg>
                  </div>
                </div>
                <event-change-notify v-if="eventNotify" :event="eventForNotify" :recurring-change="recurringChanged" :recurring-scope="recurringScope"></event-change-notify>
              </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
    <div id="subscribe-modal" class="modal fade hidden-print system-background system-label" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog system-background system-label" role="document">
        <div class="modal-content system-background system-label">
          <div class="modal-header">
            <h4 class="modal-title">Subscribe to the team calendar</h4>
          </div>
          <div class="modal-body">
            <div class="alert alert-info">
              <strong>Note:</strong> If you subscribe to the team calendar in another system, it will update once every
              5 minutes to 24 hours depending on the app used.<br/><br/>
              If you need real-time calendar updates please be sure to check the calendar in WrestlingIQ or pay
              attention to the email notifications when events change.
            </div>
            <div class="m-t-lg">
              <h2>
                On a mobile phone, using Apple iCal, or a desktop app?
              </h2>
              <p class="m-t-sm">
                Tap the button below to launch your calendar app, which will prompt you to follow a few steps to
                subscribe to the calendar.
              </p>
              <a class="btn btn-default" :href="webcal">Subscribe to calendar</a>
            </div>
            <div class="m-t-lg">
              <h2>
                Using Google Calendar or another web-based calendar?
              </h2>
              <p class="m-t-sm">
                Copy and paste the URL below into your calendar system. Depending on the system, this might be done
                either by
                "from URL" or "subscribe by URL". A step by step guide for <a
                  href="https://help.wrestlingiq.com/article/30-subscribe-to-a-team-calendar" target="_blank">Google
                Calendar can be found here</a>.
              </p>
              <code>{{ webcalHttp }}</code>
            </div>
            <div class="button-area text-right m-t-lg">
              <button type="button" class="btn btn-primary" @click="toggleSubscribeModal()">Done</button>
            </div>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
  </div>
</template>
<script>

import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import multiMonthPlugin from '@fullcalendar/multimonth';
import interactionPlugin from '@fullcalendar/interaction';
import adaptivePlugin from '@fullcalendar/adaptive';
import qs from 'qs';
import EventChangeNotify from './event_change_notify.vue';
import Spinner from './spinner.vue';
import DeleteEventForm from './delete_event_form.vue';
import RepeatedEventUpdate from './repeated_event_update.vue';
import VerticalExpander from './vertical_expander.vue';
import Search from '../../shared/search.vue';

export default {
  name: 'calendar',
  components: {
    DeleteEventForm,
    EventChangeNotify,
    RepeatedEventUpdate,
    Search,
    Spinner,
    VerticalExpander,
    FullCalendar,
  },
  props: {
    editable: {
      type: Boolean,
      default: false,
    },
    webcal: {
      type: String,
      required: false,
    },
    webcalHttp: {
      type: String,
      required: false,
    },
    showPaidSessionTagging: {
      type: Boolean,
      default: false,
    },
    showPrivateLessons: {
      type: Boolean,
      default: false,
    },
    // This is an array of profile id and profile_type pairs so we can show confirmed
    // bookings on the calendar for them, as well as show the private lesson availability callout card.
    showBookingsForProfiles: {
      type: Array,
      default: () => [],
    },
    accessKey: {
      type: String,
      required: false,
    },
    authToken: {
      type: String,
      required: false,
    },
    cloudfrontBaseUrl: {
      type: String,
      required: false,
    },
    endpoint: {
      type: String,
      required: false,
    },
    teamId: {
      type: String,
      default: 'default-key',
    },
    pendingEventInviteCount: {
      type: Number,
      default: 0,
    },
    eventBookingInvitedCount: {
      type: Number,
      default: 0,
    },
    brandColor: {
      type: String,
      required: false,
      default: '#27aa83',
    },
  },
  data() {
    const vm = this;
    return {
      dragging: false,
      deleteForm: false,
      eventForDeletion: null,
      deleteEventRecurring: false,

      cal: null,
      error: false,
      errorMessage: '',

      eventNotify: false,
      eventForNotify: false,
      recurringChanged: false,
      recurringScope: null,

      repeatedEventForUpdate: null,
      revertUpdateFunc: null,
      repeatingEventForUpdateParams: null,
      updatingRepeatedEvent: false,

      matchesLoading: false,
      matchesVisible: true,
      matchesSource: {
        id: 'matches',
        events: (fetchInfo, successCallback, failureCallback) => {
          let params = `?event_type[]=dual_meet&event_type[]=scramble&start=${fetchInfo.startStr}&end=${fetchInfo.endStr}&preventCache=${new Date()}`;
          if (vm.rosterIdParams.length > 0) {
            params = `${params}${vm.rosterIdParams}`;
          }
          if (vm.locationIdParams.length > 0) {
            params = `${params}${vm.locationIdParams}`;
          }
          const url = vm.$apiService.eventsUrl(params);
          vm.matchesLoading = true;

          vm.$apiService.loadAllPages(url, 'events')
            .then((events) => {
              vm.matchesLoading = false;
              successCallback(vm.formatFCEvents(events));
            })
            .catch((error) => {
              vm.matchesLoading = false;
              vm.error = true;
              vm.errorMessage = error.toString();
              failureCallback(error);
            });
        },
      },

      otherLoading: false,
      otherVisible: true,
      otherSource: {
        id: 'other',
        events: (fetchInfo, successCallback, failureCallback) => {
          let params = `?event_type=other&start=${fetchInfo.startStr}&end=${fetchInfo.endStr}&preventCache=${new Date()}`;
          if (vm.rosterIdParams.length > 0) {
            params = `${params}${vm.rosterIdParams}`;
          }
          if (vm.locationIdParams.length > 0) {
            params = `${params}${vm.locationIdParams}`;
          }
          const url = vm.$apiService.eventsUrl(params);
          vm.otherLoading = true;

          vm.$apiService.loadAllPages(url, 'events')
            .then((events) => {
              vm.otherLoading = false;
              successCallback(vm.formatFCEvents(events));
            })
            .catch((error) => {
              vm.otherLoading = false;
              vm.error = true;
              vm.errorMessage = error.toString();
              failureCallback(error);
            });
        },
      },

      practiceLoading: false,
      practiceVisible: true,
      practiceSource: {
        id: 'practice',
        events: (fetchInfo, successCallback, failureCallback) => {
          let params = `?event_type=practice&start=${fetchInfo.startStr}&end=${fetchInfo.endStr}&preventCache=${new Date()}`;
          if (vm.rosterIdParams.length > 0) {
            params = `${params}${vm.rosterIdParams}`;
          }
          if (vm.locationIdParams.length > 0) {
            params = `${params}${vm.locationIdParams}`;
          }
          const url = vm.$apiService.eventsUrl(params);
          vm.practiceLoading = true;

          vm.$apiService.loadAllPages(url, 'events')
            .then((events) => {
              vm.practiceLoading = false;
              successCallback(vm.formatFCEvents(events));
            })
            .catch((error) => {
              vm.practiceLoading = false;
              vm.error = true;
              vm.errorMessage = error.toString();
              failureCallback(error);
            });
        },
      },

      tournamentLoading: false,
      tournamentVisible: true,
      tournamentSource: {
        id: 'tournament',
        events: (fetchInfo, successCallback, failureCallback) => {
          let params = `?event_type=tournament&start=${fetchInfo.startStr}&end=${fetchInfo.endStr}&preventCache=${new Date()}`;
          if (vm.rosterIdParams.length > 0) {
            params = `${params}${vm.rosterIdParams}`;
          }
          if (vm.locationIdParams.length > 0) {
            params = `${params}${vm.locationIdParams}`;
          }
          const url = vm.$apiService.eventsUrl(params);
          vm.tournamentLoading = true;

          vm.$apiService.loadAllPages(url, 'events')
            .then((events) => {
              vm.tournamentLoading = false;
              successCallback(vm.formatFCEvents(events));
            })
            .catch((error) => {
              vm.tournamentLoading = false;
              vm.error = true;
              vm.errorMessage = error.toString();
              failureCallback(error);
            });
        },
      },

      privateLessonsLoading: false,
      privateLessonsVisible: false,
      privateLessonsSource: {
        id: 'private_lesson',
        events: (fetchInfo, successCallback, failureCallback) => {
          const expandParams = qs.stringify({ expand: ['event_bookings', 'private_lessons'] }, { arrayFormat: 'brackets' });
          let params = `?event_type=private_lesson&private_lesson_filter=mine&start=${fetchInfo.startStr}&end=${fetchInfo.endStr}&preventCache=${new Date()}&${expandParams}`;
          if (vm.rosterIdParams.length > 0) {
            params = `${params}${vm.rosterIdParams}`;
          }
          if (vm.locationIdParams.length > 0) {
            params = `${params}${vm.locationIdParams}`;
          }
          const url = vm.$apiService.eventsUrl(params);
          vm.privateLessonsLoading = true;

          vm.$apiService.loadAllPages(url, 'events')
            .then((events) => {
              vm.privateLessonsLoading = false;

              // Create summary events grouped by day, this is seen by all
              // Skipping summary events for beta launch, we'll add them back in after
              const summaryEvents = []; // vm.createPrivateLessonSummaryEvents(events);

              // Skipping filtered events for beta launch, we'll add them back in after we have a 'my schedule feature' available to users
              // const filteredEvents = []
              // This API endpoint should be returning filtered bookings
              // Find events that are associated with the profiles in showBookingsForProfiles so they show up as real events on the calendar
              /* const filteredEvents = _.filter(events, (event) => {
                return _.some(vm.showBookingsForProfiles, (profile) => {
                  // Check if this profile matches any of the event_bookings in the event
                  return _.some(event.event_bookings || [], (booking) => {
                    return (booking.status === 'confirmed' || booking.status === 'completed') && booking.profile_id === profile.id && booking.profile_type === profile.profile_type;
                  });
                });
              }); */

              // Format the private lesson events that relate to this profile
              const formattedConfirmedEvents = vm.formatFCEvents(events);

              // Return both the summary events and the confirmed events
              successCallback([...summaryEvents, ...formattedConfirmedEvents]);

              // Force calendar to rerender after private lessons load
              vm.$nextTick(() => {
                if (vm.$refs.calendar) {
                  vm.getCalendarForAPI().render();
                }
              });
            })
            .catch((error) => {
              vm.privateLessonsLoading = false;
              vm.error = true;
              vm.errorMessage = error.toString();
              failureCallback(error);
            });
        },
      },

      rosterFilter: 'all',
      rostersForFilter: {},

      locations: [],
      locationFilter: 'all',
      locationIdsChecked: [],

      calendarOptionsLoaded: false,
      initialView: 'dayGridMonth',
      initialDate: null,
    };
  },
  computed: {
    rostersForFilterArray() {
      return _.flatMap(this.rostersForFilter);
    },
    rosterIdsForFilter() {
      // shortcircuit for all, so that you can keep the specific ones toggled if you want
      if (this.rosterFilter === 'all') {
        return [];
      }
      return _.map(this.rostersForFilterArray, 'id');
    },
    rosterIdParams() {
      let params = '';
      this.rosterIdsForFilter.forEach((rId) => {
        params = `${params}&roster_ids[]=${rId}`;
      });

      return params;
    },
    locationIdsForFilter() {
      // shortcircuit for all, so that you can keep the specific ones toggled if you want
      if (this.locationFilter === 'all') {
        return [];
      }
      return this.locationIdsChecked;
    },
    locationIdParams() {
      let params = '';
      this.locationIdsForFilter.forEach((lId) => {
        params = `${params}&location_ids[]=${lId}`;
      });

      return params;
    },
    calendarOptions() {
      return {
        plugins: [dayGridPlugin, timeGridPlugin, listPlugin, multiMonthPlugin, interactionPlugin, adaptivePlugin],
        initialDate: this.initialDate,
        initialView: this.initialView,
        datesSet: (info) => {
          // Update hash when calendar date/view changes
          const currentDate = info.view.currentStart; // Use the currentStart date which represents the actual month being displayed
          const { view } = info;
          window.location.hash = `year=${currentDate.getFullYear()}&month=${currentDate.getMonth() + 1}&day=${currentDate.getDate()}&view=${view.type}`;
        },
        customButtons: {
          createEventBtn: {
            text: '+',
            click: this.handleCreateEventBtnClick,
          },
        },
        headerToolbar: {
          left: 'today prev,next createEventBtn',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek,multiMonthYear',
        },
        buttonText: {
          today: 'Today',
          month: 'Month',
          week: 'Week',
          day: 'Day',
          list: 'List',
          multiMonthYear: 'Year',
        },
        dragRevertDuration: 250,
        selectLongPressDelay: 500,
        navLinks: true,
        nowIndicator: true,
        editable: this.editable,
        selectable: true,
        selectMirror: true,
        timeZone: 'local',
        slotMinTime: '04:00:00',
        slotMaxTime: '23:00:00',
        scrollTime: '06:00:00',
        forceEventDuration: true,

        eventClick: (info) => {
          // Handle summary event click
          if (info.event.extendedProps.event_type === 'private_lesson_summary') {
            // For summary events, navigate to private lessons page
            window.location.assign('/private_lessons/new');
            return;
          }

          window.location.assign(`/events/${info.event.id}`);
        },
        select: (info) => {
          if (this.editable) {
            this.navigateToEventWizard(info);
          }
        },
        eventResize: (info) => {
          this.updateEvent(info.event, info.revert);
        },
        eventDrop: (info) => {
          this.updateEvent(info.event, info.revert);
        },
        eventDragStart: (info) => {
          this.dragging = true;
          this.hideDeleteForm();
        },
        eventDragStop: (info) => {
          this.dragging = false;
          const trashEl = $('#calendar-delete');
          const ofs = trashEl.offset();

          const x1 = ofs.left;
          const x2 = ofs.left + trashEl.outerWidth(true);
          const y1 = ofs.top;
          const y2 = ofs.top + trashEl.outerHeight(true);

          if (info.jsEvent.pageX >= x1 && info.jsEvent.pageX <= x2
              && info.jsEvent.pageY >= y1 && info.jsEvent.pageY <= y2) {
            const eventWithProps = this.eventWithPromotedExtendedProps(info.event);
            this.eventForDeletion = eventWithProps;
            this.deleteEventRecurring = eventWithProps.recurring;
            this.deleteForm = true;
          }
        },
        eventSources: [
          this.matchesSource,
          this.otherSource,
          this.practiceSource,
          this.tournamentSource,
          this.privateLessonsSource,
        ],
        dayMaxEvents: true,
        viewDidMount: ({ view }) => {
          localStorage.setItem(this.keyForLocalTeamStorage('calendar_view'), view.type);
        },
        schedulerLicenseKey: '0677983463-fcs-1739210166',
        eventDisplay: 'block',
        eventDidMount: (info) => {
          // Style summary events
          if (info.event.extendedProps.event_type === 'private_lesson_summary') {
            // Style the summary event to be distinct
            const eventEl = info.el;
            eventEl.classList.add('private-lesson-summary');

            // Hide in year view (multiMonthYear) only
            if (info.view.type === 'multiMonthYear') {
              eventEl.style.display = 'none';
            } else {
              // Regular calendar view styling
              // eventEl.style.display = 'inline';
              const isListView = info.view.type === 'listDay' || info.view.type === 'listWeek' || info.view.type === 'listMonth';
              if (isListView) {
                eventEl.style.borderColor = '#005f5a';
                eventEl.style.color = '#005f5a';
              } else {
                eventEl.style.borderLeft = '3px solid #00bba7';
                eventEl.style.borderColor = '#00bba7';
                eventEl.style.background = '#009689';
                eventEl.style.color = '#f0fdfa';
              }

              // Add an icon in the title on calendar views
              const titleEl = eventEl.querySelector('.fc-event-title');
              if (titleEl) {
                // Generate the icon HTML for event titles
                const iconHtml = '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 640 512" class="h-4 w-4 private-lesson-icon" style="color: #f0fdfa;"><path d="M250.6 254c0 22.3-18.1 40.4-40.4 40.4s-40.4-18.1-40.4-40.4c0-22.3 18.1-40.4 40.4-40.4s40.4 18.1 40.4 40.4zm231.9-50.2L633.9 325c6.8 5.5 8.1 15.3 2.8 22.3l-79 105.3c-4.9 6.5-13.9 8.4-20.9 4.3l-151.7-86.8c-7.6 11.4-16.4 22.3-26.5 32.4-41 41-94.7 61.5-148.5 61.5-157 0-258.4-166.6-186.8-306A64.714 64.714 0 0 1 .2 108.4c0-35.6 29-64.6 64.6-64.6 19.2 0 36.9 8.8 49.1 23.4C144 51.7 177 44.1 210 44.1c86.7 0 126.5 42.9 194.5 97.3 5.3 4.3 7.4 11.4 5.2 17.9L399.5 189c-1.1 3.2-.1 6.8 2.6 8.9l25.5 20.4c2.6 2.1 6.3 2.4 9.2.6l27.5-16.4c5.7-3.4 13-2.9 18.2 1.3zM41 129.8c6.3-8.5 13-16.8 20.7-24.5 7.8-7.8 16.1-14.6 24.7-20.9-5.9-5.3-13.5-8.3-21.6-8.3-17.8 0-32.3 14.5-32.3 32.3 0 8.1 3.3 15.6 8.5 21.4zm533.5 219.7c2.6-3.5 2-8.4-1.4-11.2l-103.4-82.7-32.3 19.2c-5.8 3.4-13.1 2.9-18.3-1.3L349.6 218c-5.3-4.3-7.4-11.4-5.2-17.9l12.1-35.2s-52-41.5-60.6-47.8C262.1 95.9 170.5 65 96 139.5 33 202.5 33 305 96 368c30.5 30.5 71.1 47.5 114.2 47.5 102.1 0 142.2-83.7 159.7-109.9L530 397.2c3.5 2 8 1.1 10.5-2.2l34-45.5z"/></svg>';
                // Check if icon already exists
                if (!titleEl.querySelector('.private-lesson-icon')) {
                  // Create a wrapper element
                  const iconElement = document.createElement('span');
                  iconElement.innerHTML = iconHtml;
                  iconElement.style.display = 'inline-block';
                  iconElement.style.marginRight = '4px';
                  iconElement.style.marginLeft = '4px';

                  // Insert the icon at the beginning of the title
                  if (titleEl.firstChild) {
                    titleEl.insertBefore(iconElement, titleEl.firstChild);
                  } else {
                    titleEl.appendChild(iconElement);
                  }
                }
              }

              // update the time title in list view
              const listTimeEl = eventEl.querySelector('.fc-list-event-time');
              if (listTimeEl) {
                // Generate the icon HTML for event titles in list views
                const iconHtml = '<svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" viewBox="0 0 640 512" class="h-4 w-4 private-lesson-icon" style="color: #005f5a;"><path d="M250.6 254c0 22.3-18.1 40.4-40.4 40.4s-40.4-18.1-40.4-40.4c0-22.3 18.1-40.4 40.4-40.4s40.4 18.1 40.4 40.4zm231.9-50.2L633.9 325c6.8 5.5 8.1 15.3 2.8 22.3l-79 105.3c-4.9 6.5-13.9 8.4-20.9 4.3l-151.7-86.8c-7.6 11.4-16.4 22.3-26.5 32.4-41 41-94.7 61.5-148.5 61.5-157 0-258.4-166.6-186.8-306A64.714 64.714 0 0 1 .2 108.4c0-35.6 29-64.6 64.6-64.6 19.2 0 36.9 8.8 49.1 23.4C144 51.7 177 44.1 210 44.1c86.7 0 126.5 42.9 194.5 97.3 5.3 4.3 7.4 11.4 5.2 17.9L399.5 189c-1.1 3.2-.1 6.8 2.6 8.9l25.5 20.4c2.6 2.1 6.3 2.4 9.2.6l27.5-16.4c5.7-3.4 13-2.9 18.2 1.3zM41 129.8c6.3-8.5 13-16.8 20.7-24.5 7.8-7.8 16.1-14.6 24.7-20.9-5.9-5.3-13.5-8.3-21.6-8.3-17.8 0-32.3 14.5-32.3 32.3 0 8.1 3.3 15.6 8.5 21.4zm533.5 219.7c2.6-3.5 2-8.4-1.4-11.2l-103.4-82.7-32.3 19.2c-5.8 3.4-13.1 2.9-18.3-1.3L349.6 218c-5.3-4.3-7.4-11.4-5.2-17.9l12.1-35.2s-52-41.5-60.6-47.8C262.1 95.9 170.5 65 96 139.5 33 202.5 33 305 96 368c30.5 30.5 71.1 47.5 114.2 47.5 102.1 0 142.2-83.7 159.7-109.9L530 397.2c3.5 2 8 1.1 10.5-2.2l34-45.5z"/></svg>';

                // Create a wrapper element
                const iconElement = document.createElement('span');
                iconElement.innerHTML = iconHtml;
                iconElement.style.display = 'inline-block';
                iconElement.style.marginRight = '4px';
                iconElement.style.marginLeft = '4px';
                listTimeEl.innerHTML = iconElement.outerHTML;
              }

              // Remove time display if it exists
              const timeEl = eventEl.querySelector('.fc-event-time');
              if (timeEl) {
                timeEl.style.display = 'none';
              }
            }
          }
        },
      };
    },
    getInitialDateFromHash() {
      const today = new Date();
      let year = today.getFullYear();
      let month = today.getMonth();
      let day = today.getDate();

      // Parse hash parameters
      const hash = window.location.hash.substring(1);
      const params = hash.split('&');

      params.forEach((param) => {
        const [key, value] = param.split('=');
        if (key === 'year') year = parseInt(value);
        if (key === 'month') month = parseInt(value) - 1;
        if (key === 'day') day = parseInt(value);
      });

      // Return null if any of the parsed values are invalid
      if (isNaN(year) || isNaN(month) || isNaN(day)) {
        return null;
      }

      // Validate month is between 0-11
      if (month < 0 || month > 11) {
        return null;
      }

      // Validate day is between 1-31
      if (day < 1 || day > 31) {
        return null;
      }

      return new Date(year, month, day);
    },
    getInitialViewFromHash() {
      const hash = window.location.hash.substring(1);
      const params = hash.split('&');
      let view = 'dayGridMonth';

      params.forEach((param) => {
        const [key, value] = param.split('=');
        if (key === 'view') view = value;
      });

      return view;
    },
  },
  mounted() {
    const vm = this;
    // set the initial date and view
    this.initialDate = this.getInitialDateFromHash;

    let savedCalendarView = this.getInitialViewFromHash;
    try {
      const savedRostersForFilter = localStorage.getItem(vm.keyForLocalTeamStorage('rosters_for_filter'));
      if (savedRostersForFilter) {
        this.rostersForFilter = JSON.parse(savedRostersForFilter);
      }

      const savedRosterFilter = localStorage.getItem(vm.keyForLocalTeamStorage('roster_filter'));
      if (savedRosterFilter) {
        this.rosterFilter = savedRosterFilter;
      }

      const savedLocationIdsChecked = localStorage.getItem(vm.keyForLocalTeamStorage('location_ids_for_filter'));
      if (savedLocationIdsChecked) {
        const parsedLocationIdsChecked = JSON.parse(savedLocationIdsChecked);
        if (Array.isArray(parsedLocationIdsChecked)) {
          this.locationIdsChecked = parsedLocationIdsChecked;
        }
      }

      const savedLocationFilter = localStorage.getItem(vm.keyForLocalTeamStorage('location_filter'));
      if (savedLocationFilter) {
        this.locationFilter = savedLocationFilter;
      }

      savedCalendarView = localStorage.getItem(vm.keyForLocalTeamStorage('calendar_view'));
    } catch (e) {
      // If we fail, assume this was corrupted client side, clear it out and return
      localStorage.removeItem(vm.keyForLocalTeamStorage('rosters_for_filter'));
      localStorage.removeItem(vm.keyForLocalTeamStorage('roster_filter'));
      localStorage.removeItem(vm.keyForLocalTeamStorage('location_ids_for_filter'));
      localStorage.removeItem(vm.keyForLocalTeamStorage('location_filter'));
      localStorage.removeItem(vm.keyForLocalTeamStorage('calendar_view'));
    }

    // Enable private lessons by default if they're enabled for this team
    if (this.showPrivateLessons) {
      this.privateLessonsVisible = true;
    }

    // Handle for valid calendar options, since this is client side, and FullCalendar sometimes changes, we need a list of valid
    // saved views
    const validViews = [
      'dayGridMonth',
      'dayGridWeek',
      'dayGridDay',
      'timeGridWeek',
      'timeGridDay',
      'listYear',
      'listMonth',
      'listWeek',
      'listDay',
      'multiMonthYear',
    ];

    if (!validViews.includes(savedCalendarView)) {
      savedCalendarView = 'dayGridMonth';
    }

    if ($(window).width() < 500) {
      savedCalendarView = 'listWeek';
    }

    // Do we even need this boolean? It might just work, but this might be better UX
    this.initialView = savedCalendarView;

    // Event handlers
    vm.$notificationManager.on('hide-delete-event-form', vm.hideDeleteForm);
    vm.$notificationManager.on('event-deleted', vm.eventDeleted);
    vm.$notificationManager.on('repeated-event-update-cancel', vm.cancelUpdateEvent);
    vm.$notificationManager.on('repeated-event-updated', vm.recurringEventUpdated);
    vm.$notificationManager.on('event-notify-close', vm.closeNotifyEvent);

    // Load the team's locations for the location filter (hidden if the team has none)
    vm.fetchLocations();

    // Calendar
    // This should render up the calendar
    vm.calendarOptionsLoaded = true;
  },
  beforeDestroy() {
    const vm = this;
    vm.$notificationManager.off('hide-delete-event-form', vm.hideDeleteForm);
    vm.$notificationManager.off('event-deleted', vm.eventDeleted);
    vm.$notificationManager.off('repeated-event-update-cancel', vm.cancelUpdateEvent);
    vm.$notificationManager.off('repeated-event-updated', vm.recurringEventUpdated);
    vm.$notificationManager.off('event-notify-close', vm.closeNotifyEvent);
  },
  watch: {
    practiceVisible(newPracticeVisible) {
      const vm = this;
      if (newPracticeVisible) {
        vm.getCalendarForAPI().addEventSource(vm.practiceSource);
      } else {
        vm.getCalendarForAPI().getEventSourceById('practice').remove();
      }
    },
    otherVisible(newOtherVisible) {
      const vm = this;
      if (newOtherVisible) {
        vm.getCalendarForAPI().addEventSource(vm.otherSource);
      } else {
        vm.getCalendarForAPI().getEventSourceById('other').remove();
      }
    },
    matchesVisible(newMatchesVisible) {
      const vm = this;
      if (newMatchesVisible) {
        vm.getCalendarForAPI().addEventSource(vm.matchesSource);
      } else {
        vm.getCalendarForAPI().getEventSourceById('matches').remove();
      }
    },
    tournamentVisible(newTournamentVisible) {
      const vm = this;
      if (newTournamentVisible) {
        vm.getCalendarForAPI().addEventSource(vm.tournamentSource);
      } else {
        vm.getCalendarForAPI().getEventSourceById('tournament').remove();
      }
    },
    privateLessonsVisible(newPrivateLessonsVisible) {
      const vm = this;
      const calApi = vm.getCalendarForAPI();
      if (!calApi) {
        return;
      }
      if (newPrivateLessonsVisible) {
        calApi.addEventSource(vm.privateLessonsSource);
      } else {
        calApi.getEventSourceById('private_lesson').remove();
      }
    },
    rosterIdsForFilter() {
      const vm = this;
      // If the component is not rendered, we don't need to refetch
      if (vm.$refs.calendar) {
        vm.getCalendarForAPI().refetchEvents();
      }
      localStorage.setItem(vm.keyForLocalTeamStorage('rosters_for_filter'), JSON.stringify(this.rostersForFilter));
    },
    rosterFilter() {
      localStorage.setItem(this.keyForLocalTeamStorage('roster_filter'), this.rosterFilter);
    },
    locationIdsForFilter() {
      const vm = this;
      // If the component is not rendered, we don't need to refetch
      if (vm.$refs.calendar) {
        vm.getCalendarForAPI().refetchEvents();
      }
      localStorage.setItem(vm.keyForLocalTeamStorage('location_ids_for_filter'), JSON.stringify(this.locationIdsChecked));
    },
    locationFilter() {
      localStorage.setItem(this.keyForLocalTeamStorage('location_filter'), this.locationFilter);
    },
  },
  methods: {
    eventWithPromotedExtendedProps(event) {
      // If the event is already formatted (no extendedProps), return it as is, we probably already promoted the extendedProps
      if (!event.extendedProps) {
        return event;
      }

      // Otherwise format the FullCalendar event object
      return {
        id: event.id,
        title: event.title,
        name: event.title,
        start: event.start,
        end: event.end,
        allDay: event.allDay,
        ...event.extendedProps,
      };
    },
    fetchLocations() {
      const vm = this;
      const url = vm.$apiService.locationsUrl();
      vm.$apiService.loadAllPages(url, 'locations')
        .then((locations) => {
          vm.locations = locations;
        })
        .catch(() => {
          // Fail silently - the location filter simply stays hidden
        });
    },
    getCalendarForAPI() {
      const calRef = this.$refs.calendar;
      if (!calRef) {
        return null;
      }
      return calRef.getApi();
    },
    handleCreateEventBtnClick() {
      if (this.editable) {
        this.navigateToEventWizard(null);
      }
    },
    // Event creation now lives on its own page (the event wizard). Drag-selects
    // pass their range along as human-facing date/time params; the wizard reads
    // them for prefill. Multi-day midnight selections become all-day events;
    // a single-day (month view) tap only picks a date — no time is implied, so
    // the wizard's time fields stay blank for an active choice.
    navigateToEventWizard(info) {
      const params = new URLSearchParams();
      if (info && info.start) {
        const start = moment(info.start);
        const end = moment(info.end || info.start);
        const isMidnight = start.hours() === 0 && start.minutes() === 0 && start.seconds() === 0;
        if (isMidnight) {
          // FullCalendar end dates are exclusive
          const isMultiDay = info.end && end.diff(start, 'days') > 1;
          if (isMultiDay) {
            params.set('start_date', start.format('YYYY-MM-DD'));
            params.set('end_date', end.subtract(1, 'day').format('YYYY-MM-DD'));
            params.set('all_day', 'true');
          } else {
            params.set('start_date', start.format('YYYY-MM-DD'));
            params.set('end_date', start.format('YYYY-MM-DD'));
          }
        } else {
          params.set('start_date', start.format('YYYY-MM-DD'));
          params.set('start_time', start.format('HH:mm'));
          params.set('end_date', end.format('YYYY-MM-DD'));
          params.set('end_time', end.format('HH:mm'));
        }
      }
      const query = params.toString();
      window.location.assign(`/events/new${query ? `?${query}` : ''}`);
    },
    keyForLocalTeamStorage(name) {
      // method that scopes local storage to this team, so sticky calendar settings is unique across teams (i.e. rosters might not exist there).
      return `${name}-${this.teamId}`;
    },
    // Toggle roster filter
    toggleRoster(roster) {
      this.$notificationManager.emit('profile-clicked', 'Roster');
      // Delete
      if (this.rostersForFilter[roster.id]) {
        // If we already have this, we should now remove it (this function is essentially a toggle)
        this.$delete(this.rostersForFilter, roster.id);

        return;
      }

      // Or set
      this.$set(this.rostersForFilter, roster.id, roster);
    },
    toggleSubscribeModal() {
      $('#subscribe-modal').modal('toggle');
    },
    recurringEventUpdated(event, needsRefetch, recurringPick) {
      const vm = this;
      vm.hideRecurringModal();
      if (needsRefetch) {
        vm.refetchSources(event);
      }
      vm.showNotifyModal(event, needsRefetch, recurringPick);
    },
    hideRecurringModal() {
      const vm = this;
      vm.updatingRepeatedEvent = false;
      vm.repeatedEventForUpdate = null;
      vm.repeatingEventForUpdateParams = null;
      $(vm.updateModalId()).modal('hide');
    },
    refetchSources(event) {
      const vm = this;
      const eventType = event.extendedProps?.event_type || event.event_type;
      // We refetch sources, if the source is currently visible. Otherwise we toggle it on, which will refetch the source anyways via the watchers.
      switch (eventType) {
        case 'practice':
          vm.practiceVisible ? vm.getCalendarForAPI().getEventSourceById('practice').refetch() : vm.practiceVisible = true;
          break;
        case 'dual_meet':
        case 'scramble':
          vm.matchesVisible ? vm.getCalendarForAPI().getEventSourceById('matches').refetch() : vm.matchesVisible = true;
          break;
        case 'tournament':
          vm.tournamentVisible ? vm.getCalendarForAPI().getEventSourceById('tournament').refetch() : vm.tournamentVisible = true;
          break;
        case 'other':
          vm.otherVisible ? vm.getCalendarForAPI().getEventSourceById('other').refetch() : vm.otherVisible = true;
          break;
        case 'private_lesson':
        case 'private_lesson_summary':
          vm.privateLessonsVisible ? vm.getCalendarForAPI().getEventSourceById('private_lesson').refetch() : vm.privateLessonsVisible = true;
          break;
      }
    },
    eventDeleted(event, recurringDeleted, recurringPick) {
      const vm = this;
      vm.refetchSources(event);
      vm.hideDeleteForm();
      vm.showNotifyModal(event, recurringDeleted, recurringPick);
    },
    hideDeleteForm() {
      const vm = this;
      vm.deleteForm = false;
      vm.eventForDeletion = null;
      vm.deleteEventRecurring = false;
    },
    formatFCEvents(events) {
      const fcEvents = [];
      events.forEach((returnedEvent) => {
        // All-day events are zone-less dates: the UTC date of the stored
        // midnight, as on the event page and in the ICS feeds. Handing
        // FullCalendar the instant would land them on the viewer's clock, a
        // day early for anyone west of where the event was entered.
        const allDayDate = (iso) => iso.split('T')[0];
        const start = returnedEvent.all_day ? allDayDate(returnedEvent.start_at) : returnedEvent.start_at;
        const end = returnedEvent.all_day ? allDayDate(returnedEvent.end_at) : returnedEvent.end_at;
        let color = returnedEvent.event_type === 'private_lesson' ? '#0A558A' : returnedEvent.color;
        let title = returnedEvent.name;
        if (returnedEvent.event_type === 'private_lesson') {
          const wrestlerBookings = returnedEvent.event_bookings.filter((booking) => booking.profile_type === 'WrestlerProfile' && (booking.status === 'confirmed' || booking.status === 'completed'));
          const confirmedWrestlerNames = _.map(wrestlerBookings, (booking) => booking.profile.display_name).join(', ');

          const coachBookings = returnedEvent.event_bookings.filter((booking) => booking.profile_type === 'CoachProfile');
          const confirmedCoachNames = _.map(coachBookings, (booking) => {
            // If the coach is unconfirmed (invited state), we should show it in yellow
            let suffix = booking.status === 'invited' ? ' (unconfirmed)' : ' ';
            color = booking.status === 'invited' ? '#E9B949' : '#00bba7';
            if (booking.status === 'cancelled') {
              suffix = ' (cancelled)';
              color = '#D64343'; // Red for cancelled
            }

            return `${booking.profile.display_name}${suffix}`;
          }).join(', ');

          title = `${confirmedCoachNames} with ${confirmedWrestlerNames}`;
        }
        const allDay = returnedEvent.all_day;
        const recurring = returnedEvent.has_repeated_events || returnedEvent.parent_id != null;
        const fcEvent = {
          id: returnedEvent.id,
          title,
          allDay,
          start,
          end,
          color,
          recurring,
          event_type: returnedEvent.event_type,
          roster_events: returnedEvent.roster_events,
          event_bookings: returnedEvent.event_bookings,
        };
        fcEvents.push(fcEvent);
      });
      return fcEvents;
    },
    updateModalId() {
      return '#event-update-modal';
    },
    notifyModalId() {
      return '#event-notify-modal';
    },
    buildParams(event) {
      const start_at = event.start.toISOString();
      let end_at;
      if (event.end) {
        end_at = event.end.toISOString();
      } else {
        // this was dropped from a all day to timed, make it two hours long
        // With forceventduration I don't think this is ever called.
        const endDate = new Date(event.start);
        endDate.setHours(endDate.getHours() + 1);
        end_at = endDate.toISOString();
      }

      let allDay = false;
      if ((event.start.getHours() === 0 && event.start.getMinutes() === 0 && event.start.getSeconds() === 0) || event.allDay) {
        allDay = true;
      }

      return {
        event: {
          start_at,
          end_at,
          all_day: allDay,
        },
      };
    },
    updateEvent(event, revertFunc) {
      const vm = this;
      const params = vm.buildParams(event);

      if (event.extendedProps.recurring && event.extendedProps.event_type !== 'private_lesson') {
        // trigger the update recurring modal
        vm.repeatedEventForUpdate = vm.eventWithPromotedExtendedProps(event);
        vm.repeatingEventForUpdateParams = params;
        vm.revertUpdateFunc = revertFunc;
        vm.updatingRepeatedEvent = true;
        $(vm.updateModalId()).modal('show');
      } else {
        // just do the update
        const updateUrl = vm.$apiService.eventUrl(event.id);
        axios.put(updateUrl, params)
          .then((response) => {
            vm.$notificationManager.emit('show-toast', `${event.title} updated`, true);
            vm.showNotifyModal(event, false);
          })
          .catch((error) => {
            const errorM = `Failed to update, reverting to previous time. ${error.toString()}`;
            vm.$notificationManager.emit('show-toast', errorM, false);
            revertFunc();
          });
      }
    },
    cancelUpdateEvent(event) {
      const vm = this;
      if (vm.repeatedEventForUpdate.id === event.id) {
        vm.revertUpdateFunc();
        vm.hideRecurringModal();
        vm.recurringChanged = false;
      }
    },
    showNotifyModal(event, recurring, recurringPick) {
      const vm = this;
      // for beta we are not handling notifications on private lessons when updating the time.
      // event may be a raw FullCalendar event (extendedProps populated) or already promoted
      // via eventWithPromotedExtendedProps (event_type at root), depending on caller.
      const eventType = event.extendedProps?.event_type || event.event_type;
      if (eventType === 'private_lesson') {
        return;
      }
      // Create a new event object with all extendedProps moved to root level
      vm.eventForNotify = vm.eventWithPromotedExtendedProps(event);
      vm.recurringChanged = recurring;
      vm.recurringScope = recurringPick === 'future' ? 'future' : null;
      vm.eventNotify = true;
      $(vm.notifyModalId()).modal('show');
    },
    closeNotifyEvent(event) {
      const vm = this;
      vm.eventNotify = false;
      vm.eventForNotify = null;
      $(vm.notifyModalId()).modal('hide');
    },
    createPrivateLessonSummaryEvents(events) {
      const vm = this;
      const summaryEvents = [];
      const dailyLessons = {};

      // Group events by date
      events.forEach((event) => {
        let dateStr;
        if (event.start_at instanceof Date) {
          dateStr = event.start_at.toISOString().split('T')[0];
        } else {
          // Handle if the date is already a string
          dateStr = new Date(event.start_at).toISOString().split('T')[0];
        }

        if (!dailyLessons[dateStr]) {
          dailyLessons[dateStr] = [];
        }
        dailyLessons[dateStr].push(event);
      });

      // Create a summary event for each day
      Object.keys(dailyLessons).forEach((dateStr) => {
        const lessonsForDay = dailyLessons[dateStr];
        const count = lessonsForDay.filter((lesson) => lesson.private_lessons.some((pl) => pl.status === 'available')).length;
        console.log(lessonsForDay);
        if (count > 0) {
          // Create a summary event for this day
          summaryEvents.push({
            id: `pl-summary-${dateStr}`,
            title: `${count} Open Private Lesson${count !== 1 ? 's' : ''}`,
            start: dateStr,
            end: dateStr,
            allDay: true,
            color: '#00bba7', // Teal color for private lessons
            isSummaryEvent: true,
            event_type: 'private_lesson_summary',
            extendedProps: {
              event_type: 'private_lesson_summary',
              isSummaryEvent: true,
              lessonCount: count,
              associatedEvents: lessonsForDay.map((e) => e.id),
            },
          });
        }
      });

      return summaryEvents;
    },
  },
};
</script>
